import * as React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import Layout from "@components/Layout"
import { graphql } from "gatsby"

import SiteMapLink from "@components/SiteMapLink"
import { blogHref, careersHref } from "@utils/navigation"
import { getDatahubTranslationKey } from "@utils/translation"
import pricePagesMapLinks from "../../modules/SiteMapPage/pricePagesMapLinks"
export default ({ pageContext }) => {
  const { t, i18n } = useTranslation()
  const [siteMapLinks2, setSiteMapLinks] = React.useState([])
  const { pricePagesLinks, materialPricePagesLinks } = pricePagesMapLinks
  const availableCountries = pageContext.availableCountries

  const localiseTitle = sitemapDef => {
    sitemapDef.title = t(sitemapDef.titleKey)
    return sitemapDef
  }

  const pricePages = localiseTitle(pricePagesLinks(availableCountries))
  const materialPricePages = localiseTitle(
    materialPricePagesLinks(availableCountries)
  )

  const onValidateName = React.useCallback(name => {
    {
      return t("Datahub_LME_Price_Updates").replace(
        "[Product]",
        t(getDatahubTranslationKey(name))
      )
    }
  }, [])

  const siteMapLinks = [
    {
      title: "Footer_GeneralInfo",
      links: [
        {
          id: 1,
          text: "Homepage",
          url: "",
        },
        {
          id: 2,
          text: "Menu-bar_About_Us",
          url: "about-us",
        },
        {
          id: 3,
          text: "Footer_Contact_us",
          url: "contact-us",
        },
        {
          id: 4,
          text: "Menu-bar_Impact",
          url: "about-us/impact",
        },
        {
          id: 5,
          text: "Menu_header_faq",
          url: "about-us/faq",
        },
        {
          id: 6,
          text: "Menu_header_casestudies",
          url: "case-studies",
        },
        {
          id: 7,
          text: "Menu_header_team",
          url: "about-us/team",
        },
      ],
    },
    {
      title: "Menu_header_solutions",
      links: [
        {
          text: "Menu_header_automotive",
          url: "solutions/automotive",
        },
        {
          text: "Menu_header_buying",
          url: "solutions/buying",
        },
        {
          text: "Menu_header_selling",
          url: "solutions/selling",
        },
        {
          text: "Menu_header_financing",
          url: "solutions/financing",
        },
        {
          text: "Menu_header_logistics",
          url: "solutions/logistics",
        },
      ],
    },
    {
      title: "Navbar_Metals",
      links: [
        {
          text: "Navbar_Copper",
          url: "metals/copper",
        },
        {
          text: "Navbar_Aluminum",
          url: "metals/aluminum",
        },
        {
          text: "Navbar_StainlessSteel",
          url: "metals/stainless-steel",
        },
        {
          text: "Navbar_FerrousMetals",
          url: "metals/ferrous",
        },
      ],
    },
    {
      title: "Footer_Careers",
      links: [
        {
          text: "Footer_LifeAtMetaloop",
          url: `${careersHref}pages/life-at-metaloop`,
        },
        {
          text: "Footer_Jobs",
          url: `${careersHref}jobs`,
        },
        {
          text: "Footer_People",
          url: `${careersHref}people`,
        },
        {
          text: "Footer_Locations",
          url: `${careersHref}locations`,
        },
        {
          text: "Footer_Departments",
          url: `${careersHref}departments`,
        },
      ],
    },
    {
      title: "Footer_Terms-and-conditions",
      links: [
        {
          text: "Footer_Terms-of-service",
          url: "terms-and-conditions",
        },
        {
          text: "Footer_Disclaimer",
          url: "disclaimer",
        },
        {
          text: "PrivacyPolicy_Header1",
          url: "privacy-policy",
        },
      ],
    },
    {
      title: "Footer_Blog",
      links: [
        {
          text: "Footer_Blog",
          url: blogHref,
        },
      ],
    },
  ]
  React.useEffect(() => {
    setSiteMapLinks([
      {
        title: "Menu-bar_Datahub",
        links: [
          {
            text: "Menu-bar_Datahub",
            url: "datahub",
          },
        ],
      },
      {
        title: "Datahub_Hero_H2_3",
        links: [
          {
            text: "EUR/USD LME-FX-rate (MTLE)",
            url: "Euro_MTLE",
          },
          {
            text: "Datahub_ECB_Fixing",
            url: "Euro_EZB",
          },
          {
            text: "Datahub_Reference Rate EUR/USD (BFIX)",
            url: "Euro_FX1",
          },
        ],
      },
      {
        title: "Menu_LMEQuotes",
        links: [
          {
            text: "Menu_LMECopper",
            url: "LME_Cu_cash",
          },
          {
            text: "Menu_LMETin",
            url: "LME_Sn_cash",
          },
          {
            text: "Menu_LMELead",
            url: "LME_Pb_cash",
          },
          {
            text: "Menu_LMEZinc",
            url: "LME_Zn_cash",
          },
          {
            text: "Menu_LMEAluminum",
            url: "LME_Al_cash",
          },
          {
            text: "Menu_LMENickel",
            url: "LME_Ni_cash",
          },
        ],
      },
      {
        title: "Datahub_H2_2",
        links: [
          {
            text: onValidateName("Copper"),
            url: "LME_Cu_cash",
          },
          {
            text: onValidateName("Tin"),
            url: "LME_Sn_cash",
          },
          {
            text: onValidateName("Lead"),
            url: "LME_Pb_cash",
          },
          {
            text: onValidateName("Zinc"),
            url: "LME_Zn_cash",
          },
          {
            text: onValidateName("Aluminium"),
            url: "LME_Al_cash",
          },
          {
            text: onValidateName("Nickel"),
            url: "LME_Ni_cash",
          },
        ],
      },
      {
        title: "Datahub_Hero_H2_4",
        links: [
          {
            text: "Datahub_Brass63_37",
            url: "MB_MS_63_37",
          },
          {
            text: "Datahub_Brass_MS58_1",
            url: "MB_MS_58_1",
          },
          {
            text: "Datahub_Brass_MS58_2",
            url: "MB_MS_58_2",
          },
          {
            text: "Datahub_Brass_MS63_wire",
            url: "MB_MS_63_wire",
          },
        ],
      },
    ])
  }, [onValidateName])
  // const siteMapLinks2 =

  if (i18n.language !== pageContext.language) {
    i18n.changeLanguage(pageContext.language)
  }

  return (
    <Layout pageContext={pageContext} theme="white-bg">
      <section className="mx-auto max-w-screen-fhd p-6 md:py-10 md:px-11 xl:p-25">
        <h1 className="text-dblue font-inter text-24 xl:text-40 font-medium leading-120% xl:leading-normal mb-4 xl:mb-6">
          {t("Footer_Sitemap")}
        </h1>

        <div className="grid md:hidden grid-cols-1 gap-5">
          {siteMapLinks.map(record => (
            <SiteMapLink key={record.title} {...record} />
          ))}
          {siteMapLinks2.map(record => (
            <SiteMapLink key={record.title} {...record} />
          ))}

          <SiteMapLink key={pricePages.title} {...pricePages} />
          <SiteMapLink key={materialPricePages.title} {...materialPricePages} />
        </div>
        {/* tablet */}
        <div className="hidden md:block xl:hidden">
          <div className="grid grid-cols-2 gap-y-4">
            <div className="flex flex-col gap-5">
              <SiteMapLink {...siteMapLinks[0]} />
              <SiteMapLink {...siteMapLinks[1]} />
              <SiteMapLink {...siteMapLinks[4]} />
            </div>
            <div className="flex flex-col gap-5">
              <SiteMapLink {...siteMapLinks[2]} />
              <SiteMapLink {...siteMapLinks[3]} />
              <SiteMapLink {...siteMapLinks[5]} />
            </div>
          </div>
          <hr className="my-5" />
          <div className="grid grid-cols-2 gap-y-4">
            <div className="flex flex-col gap-5">
              <SiteMapLink {...siteMapLinks2[0]} />
              <SiteMapLink {...siteMapLinks2[1]} />
              <SiteMapLink {...siteMapLinks2[4]} />
            </div>
            <div className="flex flex-col gap-5">
              <SiteMapLink {...siteMapLinks2[2]} />
              <SiteMapLink {...siteMapLinks2[3]} />
              <SiteMapLink {...siteMapLinks2[5]} />
            </div>
          </div>
          <hr className="my-5" />
          <div className="grid grid-cols-2 gap-y-4">
            <div className="flex flex-col gap-5">
              <SiteMapLink {...pricePages} />
            </div>
            <div className="flex flex-col gap-5">
              <SiteMapLink {...materialPricePages} />
            </div>
          </div>
        </div>

        {/* desktop */}
        <div className="hidden xl:block">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-y-5 md:gap-x-4 xl:gap-x-6 md:gap-y-4 xl:gap-y-8">
            <div>
              <SiteMapLink {...siteMapLinks[0]} />
            </div>
            <div className="flex flex-col gap-5 xl:gap-8">
              <SiteMapLink {...siteMapLinks[1]} />
              <SiteMapLink {...siteMapLinks[4]} />
            </div>
            <div className="flex flex-col gap-5 xl:gap-8">
              <SiteMapLink {...siteMapLinks[2]} />
              <SiteMapLink {...siteMapLinks[5]} />
            </div>
            <div>
              <SiteMapLink {...siteMapLinks[3]} />
            </div>
          </div>
          <hr className="my-5" />
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-4 xl:gap-x-6 xl:grid-cols-4 gap-y-5 md:gap-y-4 xl:gap-y-8">
            <div className="flex flex-col gap-5 xl:gap-8">
              <SiteMapLink {...siteMapLinks2[0]} />
              <SiteMapLink {...siteMapLinks2[1]} />
            </div>
            <div className="flex flex-col gap-5 xl:gap-8">
              <SiteMapLink {...siteMapLinks2[2]} />
            </div>
            <div className="flex flex-col gap-5 xl:gap-8">
              <SiteMapLink {...siteMapLinks2[3]} />
            </div>
            <div>
              <SiteMapLink {...siteMapLinks2[4]} />
            </div>
          </div>

          <hr className="my-5" />
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-4 xl:gap-x-6 xl:grid-cols-4 gap-y-5 md:gap-y-4 xl:gap-y-8">
            <div className="flex flex-col gap-5 xl:gap-8">
              <SiteMapLink {...pricePages} />
            </div>
            <div>
              <SiteMapLink {...materialPricePages} />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
